/*
 * @Author: zhangxu
 * @Date: 2022-04-23 17:32:28
 * @LastEditors: zhangxu
 * @LastEditTime: 2022-05-13 20:20:23
 * @FilePath: /daodao-biz-front/src/directives/loading.ts
 */
import { createLoading, Loading } from '@/components/Loading'
import type { Directive, App } from 'vue'

/**
 * 用法: v-loading="loading" loading-tip="正在加载中" loading-size="default" loading-background="#ff0000"
 *
 * @params loading 控制加载状态是否显示, boolean.
 * @params tip 加载提示语, 非必须, 默认为空.
 * @params size loading 区域字体大小, 非必须, 支持: small / default / large, 默认为 large.
 * @params background 加载区域背景颜色, 非必须, 组件已设默认颜色值.
 */
const loadingDirective: Directive = {
  mounted(el, binding) {
    const tip = el.getAttribute('loading-tip')
    const background = el.getAttribute('loading-background')
    const size = el.getAttribute('loading-size')
    const absolute = el.getAttribute('Loading-absolute') !== '0'
    const fullscreen = !!binding.modifiers.fullscreen
    const instance = createLoading(
      {
        tip,
        background,
        size: size || 'large',
        loading: !!binding.value,
        absolute: absolute,
      },
      fullscreen ? document.body : el
    )
    el.instance = instance
  },
  updated(el, binding) {
    const instance = el.instance
    if (!instance) return
    instance.setTip(el.getAttribute('loading-tip'))
    if (binding.oldValue !== binding.value) {
      if (binding.oldValue !== binding.value) {
        instance.setLoading?.(binding.value && !instance.loading)
      }
    }
  },
  unmounted(el) {
    el?.instance?.close()
  },
}

export function setupLoadingDirective(app: App) {
  app.directive('loading', loadingDirective)
}

export default loadingDirective
